export default __webpack_public_path__ + "static/media/chip_10.c6416715.svg";